<template>
  <b-container>
    <b-modal
      ref="openModal"
      class="localizationModal"
      scrollable
      size="lg"
      title="Localização"
    >
      <!-- Latitude: {{ latitude }} Longitude: {{ longitude }} -->
      <!-- {{ pin }} -->
      <div v-if="latitude == 0 && longitude == 0">
        <h4 class="danger">Esse checklist não possui localização</h4>
      </div>
      <!-- <base-map :apiKey="apiKey" :pin="pin"> </base-map> -->

      <leaflet-map id="map" ref="map" @onInitialized="fitBounds">
        <leaflet-marker
          :latitude="latitude"
          :longitude="longitude"
          marker-style="primary"
        />
      </leaflet-map>
      <!-- 
      <template #modal-footer="{ ok }">
        <div class="right">
          <b-button variant="red" @click="ok()"> 
          {{ $t('geral.close') }}
          </b-button>
        </div>
      </template> -->
      <template #modal-footer="{ cancel }">
        <div class="w-100">
          <div class="float-right">
            <b-button class="mr-2" variant="primary" @click="fitBounds()">
              Recentralizar
            </b-button>
            <b-button variant="danger" @click="cancel()">
              {{ $t("geral.close") }}
            </b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </b-container>
</template>
<script>
export default {
  name: "ChecklistFilledMap",
  props: {
    latitude: Number,
    longitude: Number,
  },
  components: {
    // BaseMap: () => import("@/components_rms/base/BaseMap.vue"),
    LeafletMap: () => import("@/components_rms/base/leaflet/LeafletMap.vue"),
    LeafletMarker: () =>
      import("@/components_rms/base/leaflet/LeafletMarker.vue"),
  },
  data() {
    return {
      apiKey:
        "As-Vkf2McY-jBXfx3q_vrpwdrFmtyixvHjGFuv90Ak2WD338py0sIQ7wCf5z2D80", //chave da api
      pin: {
        key: "pin1",
        location: {
          latitude: 0,
          longitude: 0,
        },
        visible: true,
      },
    };
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    openModal() {
      this.$refs.openModal.show();
    },
    openImage() {
      this.$refs.fullscreenSidebar.open();
    },
    fitBounds() {
      if (!this.$refs.map) return;
      if (this.latitude != 0.0 && this.longitude != 0.0) {
        this.$refs.map.fitBounds([[this.latitude, this.longitude]]);
      }
    },
  },
  watch: {
    latitude() {
      if (this.latitude != 0) this.pin.location.latitude = this.latitude;
    },
    longitude() {
      if (this.longitude != 0) this.pin.location.longitude = this.longitude;
    },
  },
};
</script>
<style scoped>
.btn_localization {
  /* margin-left: 40%; */
  margin-top: -55px;
}
.danger {
  color: #fd5d93 !important;
}
</style>